var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2360_3074)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8125 20.3125H13.4375C14.1279 20.3125 14.6875 20.8722 14.6875 21.5625V32.1875C14.6875 32.8778 14.1279 33.4375 13.4375 33.4375H2.8125C2.12214 33.4375 1.5625 32.8778 1.5625 32.1875V21.5625C1.5625 20.8722 2.12214 20.3125 2.8125 20.3125ZM21.5625 20.3125H32.1875C32.8778 20.3125 33.4375 20.8722 33.4375 21.5625V32.1875C33.4375 32.8778 32.8778 33.4375 32.1875 33.4375H21.5625C20.8722 33.4375 20.3125 32.8778 20.3125 32.1875V21.5625C20.3125 20.8722 20.8722 20.3125 21.5625 20.3125Z",
    fill: "#FDDC5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 0C10.6467 0 9.3875 1.2592 9.3875 2.8125V13.4375C9.3875 14.9908 10.6467 16.25 12.2 16.25H22.825C24.3783 16.25 25.6375 14.9908 25.6375 13.4375V2.8125C25.6375 1.2592 24.3783 0 22.825 0H12.2ZM3.125 31.875V21.875H13.125V31.875H3.125ZM2.8125 18.75C1.2592 18.75 0 20.0092 0 21.5625V32.1875C0 33.7407 1.2592 35 2.8125 35H13.4375C14.9908 35 16.25 33.7407 16.25 32.1875V21.5625C16.25 20.0092 14.9908 18.75 13.4375 18.75H2.8125ZM21.875 21.875V31.875H31.875V21.875H21.875ZM18.75 21.5625C18.75 20.0092 20.0092 18.75 21.5625 18.75H32.1875C33.7407 18.75 35 20.0092 35 21.5625V32.1875C35 33.7407 33.7407 35 32.1875 35H21.5625C20.0092 35 18.75 33.7407 18.75 32.1875V21.5625Z",
    fill: "#0C098C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2360_3074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGap);
export default __webpack_public_path__ + "static/media/Gap.7ba077234e42f29cde8c8287896edf26.svg";
export { ForwardRef as ReactComponent };